import { Loader } from '../../../components/Loader/Loader.jsx';
import { Button, Form } from 'react-bootstrap';
import FormPasswordEye from '../../../components/FormPasswordEye/FormPasswordEye.jsx';
import { useCallback } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useLocation } from 'react-router';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    makeSelectAppFormError,
    makeSelectAppLoggedIn,
    makeSelectAppLoggedInProcess,
} from '../../../app/appSelectors.js';
import { MobileRouterPaths } from '../../mobileAppConstants.js';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { MobileAppForgotPasswordLinkContainerStyled, MobileAppLoginStyled } from './styled/MobileAppLoginStyled';
import { loginAction } from '../../../modules/Login/loginActions';
import { useLocationProviderContext } from '../../../providers/LocationProvider/LocationProviderContext';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { logAppsflyerAction, resetFormErrorAction } from '../../../app/appActions';
import { LOG_AF_EVENT_NAMES } from '../../../app/appConstants';
import { useInitialUrlSearchParams } from '../../../hooks/useInitialUrlSearchParams';
import { useFormFieldErrors } from '../../../hooks/useFormFieldErrors';
import { LOGIN_FIELDS_ERRORS } from '../../../modules/Login/components/loginConstants';

function MobileAppLogin(props) {
    const location = useLocation();
    const {
        login,
        logAppsflyer,
        isLoginLoading,
        isLoggedIn,
        loginError,
        resetFormError,
    } = props;
    const { getLangPath } = useLangContext();
    const { prevLocation } = useLocationProviderContext();
    const { email: initialEmail } = useInitialUrlSearchParams(['email']);
    const { email: emailError, password: passwordError, common: commonError } =
        useFormFieldErrors(LOGIN_FIELDS_ERRORS, loginError);

    useEffectOnce(() => {
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.LOGIN_SHOWN,
            payload: { source: prevLocation.pathname || 'None' },
        });
    });

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        login({
            email: e.target.querySelector('[name=email]').value,
            password: e.target.querySelector('[name=password]').value,
            onSuccessCallback: () => logAppsflyer({
                name: LOG_AF_EVENT_NAMES.LOGIN_COMPLETED,
                payload: { method: 'password' },
            }),
            onFailureCallback: (errorCode) => logAppsflyer({
                name: LOG_AF_EVENT_NAMES.LOGIN_ERROR,
                error_code: errorCode || 'error.something_went_wrong',
            }),
        });
    }, [logAppsflyer, login]);

    const handleChange = useCallback((isValid) => {
        if (!isValid) {
            resetFormError();
        }
    }, [resetFormError]);

    if (isLoggedIn) {
        return <Redirect to={{
            pathname: location.state?.originPathname || MobileRouterPaths.default,
            search: location.state?.originSearch,
        }} />;
    }
    return <MobileAppLoginStyled>
        <Loader show={isLoginLoading} />
        <div className="px-3">
            <h1 className="mb-0 text-center">{getLangPath('promo.fx.log_in')}</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4 mt-2rem">
                    <Form.Control
                        className="mt-3"
                        defaultValue={initialEmail || ''}
                        isInvalid={!!emailError}
                        name="email"
                        onChange={() => handleChange(!emailError)}
                        placeholder={getLangPath('lite_version.sign_up.enter_email')}
                        required
                        type="email"
                    />
                    {
                        !!emailError && <>
                            <Form.Control.Feedback type="invalid">
                                {getLangPath(emailError)}
                            </Form.Control.Feedback>
                        </>
                    }
                </Form.Group>

                <Form.Group className="mt-3" controlId="formBasicPassword">
                    <FormPasswordEye
                        name="password"
                        onChange={() => handleChange(!passwordError)}
                        placeholder={getLangPath('lite_version.sign_up.enter_password')}
                        isInvalid={!!passwordError}
                        required
                    />
                    {
                        !!passwordError && <>
                            <Form.Control.Feedback type="invalid">
                                {getLangPath(passwordError)}
                            </Form.Control.Feedback>
                        </>
                    }
                </Form.Group>
                {
                    !!commonError && (
                        <Form.Control.Feedback type="invalid" className="d-block mt-3">
                            {getLangPath(commonError)}
                        </Form.Control.Feedback>
                    )
                }
                <MobileAppForgotPasswordLinkContainerStyled>
                    <Link to={MobileRouterPaths.forgot} className="color-white">
                        {getLangPath('promo.fx.sign_in.password')}
                    </Link>
                </MobileAppForgotPasswordLinkContainerStyled>
                <div className="d-flex flex-column mt-2rem" style={{ marginBottom: '80px' }}>
                    <Button size="lg" type="submit">
                        {getLangPath('promo.fx.log_in')}
                    </Button>
                    {/*<Button variant="outline-info" size="md" onClick={handleRegistrationClick} type="button"*/}
                    {/*        className="mt-3">*/}
                    {/*    {getLangPath('sign_up.title')}*/}
                    {/*</Button>*/}
                </div>
            </Form>
        </div>
    </MobileAppLoginStyled>;
}

const mapStateToProps = createStructuredSelector({
    isLoggedIn: makeSelectAppLoggedIn(),
    isLoginLoading: makeSelectAppLoggedInProcess(),
    loginError: makeSelectAppFormError(),
});

const mapDispatchToProps = (dispatch) => ({
    login: (payload) => dispatch(loginAction(payload)),
    logAppsflyer: (payload) => dispatch(logAppsflyerAction(payload)),
    resetFormError: (payload) => dispatch(resetFormErrorAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppLogin);
